import React, { useState, useEffect } from 'react';
import { useCookies } from '../../context/CookieContext';
import './CookieSettingsPage.css';

const CookieSettingsPage = () => {
  const { cookiePreferences, updateCookiePreferences } = useCookies();
  const [localPreferences, setLocalPreferences] = useState(cookiePreferences);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setLocalPreferences(cookiePreferences);
  }, [cookiePreferences]);

  useEffect(() => {
    const changed = JSON.stringify(localPreferences) !== JSON.stringify(cookiePreferences);
    setHasChanges(changed);
  }, [localPreferences, cookiePreferences]);

  const handleToggle = (key) => {
    if (key === 'necessary') return; // Gerekli çerezler değiştirilemez
    
    setLocalPreferences(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSave = () => {
    updateCookiePreferences(localPreferences);
    setHasChanges(false);
  };

  const handleReset = () => {
    setLocalPreferences(cookiePreferences);
    setHasChanges(false);
  };

  const cookieTypes = [
    {
      key: 'necessary',
      title: 'Gerekli Çerezler',
      description: 'Bu çerezler web sitesinin temel işlevleri için gereklidir ve devre dışı bırakılamaz. Örnek: oturum yönetimi, güvenlik, temel site işlevleri.',
      required: true
    },
    {
      key: 'analytics',
      title: 'Analitik Çerezler',
      description: 'Bu çerezler web sitesinin nasıl kullanıldığını anlamamıza yardımcı olur ve performansı iyileştirir. Örnek: sayfa görüntüleme sayıları, kullanıcı davranışları, site performansı.',
      required: false
    },
    {
      key: 'marketing',
      title: 'Pazarlama Çerezleri',
      description: 'Bu çerezler size ilgi alanlarınıza uygun reklamlar göstermek için kullanılır. Örnek: hedefli reklamlar, sosyal medya entegrasyonu, reklam performansı.',
      required: false
    },
    {
      key: 'preferences',
      title: 'Tercih Çerezleri',
      description: 'Bu çerezler dil, bölge ve diğer kişiselleştirme seçeneklerinizi hatırlar. Örnek: dil tercihi, bölge ayarları, tema seçimi.',
      required: false
    }
  ];

  return (
    <div className="cookie-settings-page">
      <div className="cookie-settings-container">
        <div className="cookie-settings-header">
          <h1>Çerez Ayarları</h1>
          <p>
            Bu sayfa, web sitemizde kullanılan çerezler hakkında detaylı bilgi sağlar 
            ve çerez tercihlerinizi yönetmenize olanak tanır.
          </p>
        </div>

        <div className="cookie-settings-content">
          {cookieTypes.map((cookieType) => (
            <div key={cookieType.key} className="cookie-type-card">
              <div className="cookie-type-header">
                <div className="cookie-type-info">
                  <h3>{cookieType.title}</h3>
                  <p>{cookieType.description}</p>
                  {cookieType.required && (
                    <span className="cookie-required">Gerekli</span>
                  )}
                </div>
                <div className="cookie-type-toggle">
                  <input
                    type="checkbox"
                    checked={localPreferences[cookieType.key]}
                    onChange={() => handleToggle(cookieType.key)}
                    disabled={cookieType.required}
                    id={`cookie-${cookieType.key}`}
                  />
                  <label 
                    htmlFor={`cookie-${cookieType.key}`}
                    className={`toggle-switch ${cookieType.required ? 'disabled' : ''}`}
                  >
                    <span className="toggle-slider"></span>
                  </label>
                  <span className="toggle-status">
                    {localPreferences[cookieType.key] ? 'Aktif' : 'Pasif'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cookie-settings-actions">
          <button 
            className="cookie-btn cookie-btn-secondary" 
            onClick={handleReset}
            disabled={!hasChanges}
          >
            Değişiklikleri Geri Al
          </button>
          <button 
            className="cookie-btn cookie-btn-primary" 
            onClick={handleSave}
            disabled={!hasChanges}
          >
            Değişiklikleri Kaydet
          </button>
        </div>

        <div className="cookie-settings-info">
          <h3>Çerezler Hakkında Daha Fazla Bilgi</h3>
          <div className="cookie-info-grid">
            <div className="cookie-info-item">
              <h4>Çerez Nedir?</h4>
              <p>
                Çerezler, web sitelerinin tarayıcınızda küçük metin dosyaları olarak 
                sakladığı bilgilerdir. Bu dosyalar, web sitesinin sizi hatırlamasını 
                ve deneyiminizi kişiselleştirmesini sağlar.
              </p>
            </div>
            <div className="cookie-info-item">
              <h4>Çerezler Nasıl Çalışır?</h4>
              <p>
                Web sitesini ziyaret ettiğinizde, sunucu tarayıcınıza çerez gönderir. 
                Tarayıcı bu çerezi saklar ve sonraki ziyaretlerinizde sunucuya geri gönderir.
              </p>
            </div>
            <div className="cookie-info-item">
              <h4>Çerezleri Nasıl Yönetebilirim?</h4>
              <p>
                Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. 
                Ancak bu, bazı web sitesi özelliklerinin çalışmamasına neden olabilir.
              </p>
            </div>
            <div className="cookie-info-item">
              <h4>Çerez Tercihlerimi Değiştirebilir miyim?</h4>
              <p>
                Evet, bu sayfadan istediğiniz zaman çerez tercihlerinizi değiştirebilirsiniz. 
                Değişiklikler anında uygulanır ve gelecekteki ziyaretlerinizde korunur.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieSettingsPage;
